import styled from 'styled-components';
import {
    PlayerNameWrapper,
    PlayerPregameWrapper,
    PlayerStatsWrapper,
    PlayerInfoWrapper,
    PlayerDataWrapper,
    PlayerMatchupHeadshotWrapper,
    PlayerMatchupWrapper
} from '@mlb/react-patterns/components/PlayerMatchup/playerMatchup.style';
import { ImageWrapper } from '@mlb/react-patterns/components/Image/image.style';
import { PlayerDuelStatsDash, StatsDividerWrapper } from '../PlayerDuel/PlayerDuel.style';

const SINGLENARROW = 'singlenarrow';
const FULLNARROW = 'fullnarrow';

export const PlayerListWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    display: flex;
    flex-flow: ${({ $type }) => ($type === SINGLENARROW || $type === FULLNARROW ? 'column' : 'row')};
    justify-content: ${({ $type }) => ($type === SINGLENARROW || $type === FULLNARROW ? 'flex-start' : 'space-between')};
    
    ${({ $type }) => {
        if ($type === SINGLENARROW || $type === FULLNARROW) {
            return `
                margin-left: 0;
                margin-right: 0;
            `;
        }
    }};
`;

export const PlayerListItemWrapper = styled.div`
    position: relative;
    &:last-child {
        margin-bottom: ${({ $type }) => ($type === FULLNARROW || $type === SINGLENARROW ? '0' : '16px')};
    }
`;

export const DueUpPlayerListItemWrapper = styled(PlayerListItemWrapper)`
    ${({ $type }) => {
        if ($type !== SINGLENARROW && $type !== FULLNARROW) {
            return `
                margin-right: auto;
                width: 31%;
            `;
        } else {
            return `
                a {
                    display: block;
                    width: fit-content;
                    margin-bottom: 16px;
                }
            `;
        }
    }};
    
    ${PlayerNameWrapper} {
        font-weight: bold;
        font-size: 14px;
        height: fit-content;
        line-height: 14px;
        color: var(--gameday-primary-font-color);
    }
    ${PlayerInfoWrapper} {
        height: fit-content;
    }
    ${PlayerPregameWrapper} {
        font-weight: 500;
        font-size: 12px;
        margin-left: 5px;
        height: 12px;
        display: flex;
        align-items: center;
        margin-top: 1px;
        color: var(--gameday-secondary-font-color);
    }
    ${PlayerStatsWrapper} {
        font-size: 12px;
        line-height: 12px;
        text-align: left;

        ${({ $type }) => {
        if ($type !== SINGLENARROW && $type !== FULLNARROW) {
            return `
                    .before-list {
                        display: inline-block;
                        margin-top: 1px;
                    }
                    .after-list {
                        display: inline-block;
                        margin-top: 4px;
                    }
                `;
        }
    }};
    }
    ${PlayerDataWrapper} {
        margin-left: 0;

        ${PlayerInfoWrapper} {
            margin-bottom: 0px;
            margin-top: 1px;
        }
    }
    ${ImageWrapper} {
        ${({ $type }) => {
        if ($type === SINGLENARROW || $type === FULLNARROW) {
            return `
                    height: 32px !important;
                    width: 32px !important;
                `;
        } else {
            return `
                    height: 48px !important;
                    width: 48px !important;
                `;
        }
    }};
    }
    ${PlayerMatchupHeadshotWrapper} {
        max-height: ${({ $type }) => ($type === SINGLENARROW || $type === FULLNARROW ? '32px' : '48px')};
        margin: ${({ $type }) => ($type === SINGLENARROW || $type === FULLNARROW ? '0 8px 0 0' : '0 16px 0 24px')};
    }

    ${PlayerMatchupWrapper} {
        ${({ $type }) => {
        if ($type !== SINGLENARROW && $type !== FULLNARROW) {
            return `
                    align-items: flex-start;
                `;
        }
    }};
    }
    ${StatsDividerWrapper} {
        ${({ $type }) => {
        if ($type !== SINGLENARROW && $type !== FULLNARROW) {
            return `
                    display: none;
                `;
        }
    }};
    }

    ${PlayerDuelStatsDash} {
        display: ${({ $type }) => ($type === SINGLENARROW || $type === FULLNARROW) ? 'none' : 'block'};
    }
`;

export const PlayerListTitle = styled.div`
    font-size: 15px;
    font-weight: 900;
    color: var(--gameday-secondary-font-color);
    text-align: center;
    margin: 15px 0 7px;
`;

export const DueUpPlayerListTitle = styled.div`
    color: var(--gameday-secondary-font-color);
    font-weight: bold;
    line-height: 14px;

    ${({ $type }) => {
        if ($type !== SINGLENARROW && $type !== FULLNARROW) {
            return `
                margin-bottom: -8px;
                font-size: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
            `;
        } else {
            return `
                margin-bottom: 16px;
                font-size: 14px;
            `;
        }
    }};

    ${({ $type }) => {
        if ($type === SINGLENARROW) {
            return `
                margin-top: 16px;
            `;
        } else if ($type === FULLNARROW) {
            return `
                margin-top: 0px;
            `;
        } else {
            return `
                margin-top: 8px;
            `;
        }
    }};
`;

export const DueUpOrderNum = styled.div`
    position: absolute;
    left: 0px;
    font-size: 14px;
    line-height: 14px;
    font-weight: bold;
    padding-top: ${({ $type }) => ($type === SINGLENARROW || $type === FULLNARROW) ? '10px' : '8px'};
    color: var(--gameday-secondary-font-color);
`;

export const InfoDivider = styled.div`
    height: 1px;
    background-color: var(--gameday-divider-color);
`;

export const DueUpDivider = styled.div`
    width: 1px;
    background-color: var(--gameday-divider-color);
    height: 46px;
    margin: 0 20px 0 8px;
`;
